
<div class="progress-bar">
  <div *ngFor="let checkpoint of checkpoints; let i = index" class="checkpoint"  [class.active]="i < iteration"
  [class.blink]="i === iteration">
  </div>
</div>

